import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconPaperClip = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.938 21.343'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M11.101,21.343 C10.846,21.343 10.591,21.243 10.396,21.046 C10.006,20.649 10.006,20.007 10.396,19.611 L20.746,9.088 C21.518,8.304 21.943,7.260 21.943,6.151 C21.943,5.042 21.518,3.999 20.746,3.216 C19.153,1.596 16.561,1.597 14.969,3.216 L2.963,15.422 C2.286,16.111 1.961,16.774 1.997,17.394 C2.032,17.998 2.407,18.464 2.628,18.687 C3.000,19.066 3.403,19.224 3.855,19.165 C4.423,19.093 5.076,18.696 5.745,18.016 L15.166,8.437 C15.555,8.041 16.187,8.041 16.576,8.437 C16.966,8.833 16.966,9.476 16.576,9.871 L7.156,19.451 C6.156,20.467 5.129,21.048 4.102,21.178 C3.026,21.314 2.029,20.948 1.217,20.122 C0.491,19.384 0.060,18.458 0.005,17.515 C-0.067,16.291 0.454,15.104 1.552,13.988 L13.558,1.781 C15.929,-0.629 19.787,-0.629 22.157,1.781 C23.305,2.947 23.938,4.500 23.938,6.151 C23.938,7.802 23.305,9.355 22.157,10.523 L11.807,21.046 C11.612,21.243 11.357,21.343 11.101,21.343 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconPaperClip.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
